import React, {Component} from 'react';

// Components
import CampaignWrapUpHeader from './campaign_wrap_up_header';
import CampaignWrapUpAnalytics from './campaign_wrap_up_analytics';
import ContentLeaderboard from './content_leaderboard';
import CreatorParticipationAnalytics from './creator_participation_analytics';
import AudienceAnalytics from './audience_analytics';
import Amplification from './amplification';
import RepurposeSuggestions from './repurpose_suggestions';
import AccountManager from './account_manager';
import ConsumerSentiment from './consumer_sentiment';

const WHITE = '#ffffff';
const GRAY = '#f6f4f4';

class CampaignWrapUpPage extends Component {
    getAssetPath = asset => {
        const {renderForPdf, appUrl} = this.props;

        if (renderForPdf) {
            return `${appUrl}${asset}`;
        }

        return asset;
    };

    getBackgroundColor = () => {
        const {renderForPdf} = this.props;

        if (renderForPdf) {
            return WHITE;
        }

        if (this.currentBackgroundColor === WHITE) {
            this.currentBackgroundColor = GRAY;
        } else {
            this.currentBackgroundColor = WHITE;
        }

        return this.currentBackgroundColor;
    };

    currentBackgroundColor = WHITE;

    render() {
        const {
            renderForPdf,
            useConsumerSentiment,
            useCreatorAnalytics,
            useAudienceAnalytics
        } = this.props;

        return (
            <div className="campaign-wrap-up-page">
                <CampaignWrapUpHeader
                    brandLogoUrl={this.props.brandLogoUrl}
                    brandName={this.props.brandName}
                    campaignName={this.props.campaignName}
                    startDate={this.props.startDate}
                    endDate={this.props.endDate}
                    topImages={this.props.topImages}
                    renderForPdf={renderForPdf}
                    getAssetPath={this.getAssetPath}
                    bgColor={WHITE}
                />
                <CampaignWrapUpAnalytics
                    contentCount={this.props.contentCount}
                    totalReach={this.props.totalReach}
                    engagements={this.props.engagements}
                    engagementRate={this.props.engagementRate}
                    ecpx={this.props.ecpx}
                    objectiveBid={this.props.objectiveBid}
                    objectiveBidType={this.props.objectiveBidType}
                    percentDelivered={this.props.percentDelivered}
                    campaignType={this.props.campaignType}
                    showVideoViews={this.props.showVideoViews}
                    renderForPdf={renderForPdf}
                    getAssetPath={this.getAssetPath}
                    bgColor={WHITE}
                />
                <ContentLeaderboard
                    brandId={this.props.brandId}
                    campaignId={this.props.campaignId}
                    campaignName={this.props.campaignName}
                    downloadUrl={this.props.downloadUrl}
                    isAdmin={this.props.isAdmin}
                    leaderboardContent={this.props.leaderboardContent}
                    showKoer={this.props.showKoer}
                    showVideoViews={this.props.showVideoViews}
                    analyticsUrl={this.props.analyticsUrl}
                    renderForPdf={renderForPdf}
                    bgColor={this.getBackgroundColor()}
                />
                {useConsumerSentiment ? (
                    <ConsumerSentiment
                        consumer_sentiment={this.props.consumerSentiment}
                        renderForPdf={renderForPdf}
                        bgColor={this.getBackgroundColor()}
                    />
                ) : null}
                {useCreatorAnalytics ? (
                    <CreatorParticipationAnalytics
                        creatorAnalysis={this.props.creatorAnalysis}
                        renderForPdf={renderForPdf}
                        getAssetPath={this.getAssetPath}
                        bgColor={this.getBackgroundColor()}
                    />
                ) : null}
                {useAudienceAnalytics ? (
                    <AudienceAnalytics
                        audienceAnalysis={this.props.audienceAnalysis}
                        renderForPdf={renderForPdf}
                        getAssetPath={this.getAssetPath}
                        bgColor={this.getBackgroundColor()}
                    />
                ) : null}
                <Amplification
                    topImages={this.props.topImages}
                    renderForPdf={renderForPdf}
                    getAssetPath={this.getAssetPath}
                    bgColor={this.getBackgroundColor()}
                />
                {!renderForPdf ? (
                    <RepurposeSuggestions
                        renderForPdf={renderForPdf}
                        getAssetPath={this.getAssetPath}
                        bgColor={this.getBackgroundColor()}
                    />
                ) : null}
                <AccountManager
                    analyticsUrl={this.props.analyticsUrl}
                    campaignId={this.props.campaignId}
                    campaignName={this.props.campaignName}
                    firstName={this.props.accountManager.first_name}
                    email={this.props.accountManager.email}
                    profilePictureUrl={this.props.accountManager.profile_picture_url}
                    defaultProfilePicture={this.props.defaultProfilePicture}
                    campaignWrapUpExportUrl={this.props.campaignWrapUpExportUrl}
                    campaignWrapUpPdfUrl={this.props.campaignWrapUpPdfUrl}
                    viewCampaignsUrl={this.props.viewCampaignsUrl}
                    renderForPdf={renderForPdf}
                />

                {/*STYLES*/}

                <style>{`
                    .campaign-wrap-up-page {

                    }
                `}</style>

                {/*STYLE FOR WEB*/}
                {!renderForPdf ? (
                    <style>{`
                        .help-bubble {
                            display: inline;
                        }

                        .help-bubble .fa-question-circle {
                            float: none;
                            width: auto;
                            height: auto;
                            line-height: 0px;
                            color: #575757;
                            padding-left: 4px;
                        }

                        .help-bubble div {
                            width: 300px;
                            box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
                        }
                    `}</style>
                ) : null}

                {/*STYLE FOR PDF*/}
                {renderForPdf ? (
                    <link
                        href="https://fonts.googleapis.com/css?family=Open%20Sans%3A400%2C600%2C700%2C300%7CTitillium%20Web%3A200%2C300%2C400"
                        rel="stylesheet"
                        type="text/css"
                    />
                ) : null}
                {renderForPdf ? (
                    <style>{`
                        .campaign-wrap-up-page {
                            font-family: Open Sans, sans-serif;
                            -webkit-font-smoothing: antialiased;
                        }

                        .plotly {
                            margin: 0px;
                            padding: 0px;
                        }

                        .plotly .svg-container {
                            margin: auto;
                        }

                        .plotly .svg-container .main-svg {
                            position: absolute;
                            top: 0px;
                            left: 0px;
                            pointer-events: none;
                        }
                    `}</style>
                ) : null}
            </div>
        );
    }
}

CampaignWrapUpPage.propTypes = {};

export default CampaignWrapUpPage;



// WEBPACK FOOTER //
// ./campaign_analytics/campaign_wrap_up/campaign_wrap_up_page.js